var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneEmailAdd04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 183.35 186.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#86d1d7;}.cls-2{fill:#2e2b7c;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.32,
    y: 12.85,
    width: 160.72,
    height: 160.72,
    rx: 23.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.68,62.49A14.28,14.28,0,1,0,106,76.77,14.3,14.3,0,0,0,91.68,62.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.68,31.14A47.92,47.92,0,0,0,43.75,79.07c0,22.57,34.84,63.4,45.11,74.94a3.76,3.76,0,0,0,5.63,0c10.27-11.54,45.12-52.37,45.12-74.94A47.93,47.93,0,0,0,91.68,31.14Zm0,69.33a23.7,23.7,0,1,1,23.69-23.7A23.72,23.72,0,0,1,91.68,100.47Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneEmailAdd04);
export default __webpack_public_path__ + "static/media/phoneEmailAdd-04.103ad7bd5221838e16d03ac5b911f12d.svg";
export { ForwardRef as ReactComponent };